"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMedia;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _MediaConstants = require("./MediaConstants");

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

function UIMedia(props) {
  var align = props.align,
      children = props.children,
      className = props.className,
      collapsed = props.collapsed,
      spacing = props.spacing,
      rest = (0, _objectWithoutProperties2.default)(props, ["align", "children", "className", "collapsed", "spacing"]);

  if (collapsed) {
    _devLogger.default.warn({
      message: 'UIMedia: the `collapsed` prop is deprecated in favor of ' + '`spacing="none"` and may be removed in the future.',
      key: 'UIMedia: collapsed prop deprecated'
    });
  }

  return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('media', 'private-media', _MediaConstants.MEDIA_ALIGNMENT_TYPES[align], _MediaConstants.MEDIA_SPACING[spacing], {
      'private-media--collapsed': collapsed
    }, className)
  }), children);
}

UIMedia.displayName = 'UIMedia';
UIMedia.propTypes = {
  align: _propTypes.default.oneOf(Object.keys(_MediaConstants.MEDIA_ALIGNMENT_TYPES)),
  children: _propTypes.default.node.isRequired,
  collapsed: _propTypes.default.bool.isRequired,
  spacing: _propTypes.default.oneOf(Object.keys(_MediaConstants.MEDIA_SPACING)).isRequired
};
UIMedia.defaultProps = {
  collapsed: false,
  spacing: 'small'
};
module.exports = exports.default;